var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Communication/notification.on"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.2978 15.75C10.166 15.9771 9.97672 16.1656 9.74901 16.2967C9.52129 16.4277 9.26312 16.4967 9.00034 16.4967C8.73755 16.4967 8.47938 16.4277 8.25167 16.2967C8.02396 16.1656 7.8347 15.9771 7.70284 15.75M13.2002 6.11999C13.2002 4.97425 12.7577 3.87544 11.97 3.06529C11.1824 2.25513 10.1141 1.79999 9.0002 1.79999C7.88629 1.79999 6.818 2.25513 6.03035 3.06529C5.24269 3.87544 4.8002 4.97425 4.8002 6.11999C4.8002 11.16 2.7002 12.6 2.7002 12.6H15.3002C15.3002 12.6 13.2002 11.16 13.2002 6.11999Z",
    stroke: "#231F20",
    strokeWidth: 1.99832,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationon);
export default __webpack_public_path__ + "static/media/notification.on.f30672d57ee0a9fe53771c798c5faf1f.svg";
export { ForwardRef as ReactComponent };